import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { buildProgress, NAV_GROUPS, NAV_ITEMS } from '../navigation.js';
import { useTheme } from '../lib/theme.js';

export function Shell({
  userName,
  roles,
  onSignOut,
}: {
  userName: string;
  roles: readonly string[];
  onSignOut: () => void;
}): JSX.Element {
  const progress = buildProgress();
  const { pathname } = useLocation();
  const { theme, toggle } = useTheme();
  const current = NAV_ITEMS.find((i) => i.path === pathname);

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          {/* Reversed variant: the same published logo with the purple wordmark
              lightened, because the brand purple is invisible on this surface. */}
          <img className="brand-logo" src="/brand/logo-reversed.svg" alt="TwentyFour IT Services" />
          <div className="brand-mark">Growth Engine</div>
          <div className="brand-sub">Advertising intelligence</div>
        </div>
        <nav className="nav">
          {NAV_GROUPS.map((group) => (
            <div key={group}>
              <div className="nav-group">{group}</div>
              {NAV_ITEMS.filter((i) => i.group === group).map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  className={({ isActive }) => (isActive ? 'active' : undefined)}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-foot">
          <div className="who">{userName}</div>
          <div className="who-role">{roles.length > 0 ? roles.join(', ') : 'No role assigned'}</div>
          <button className="btn btn-ghost" style={{ marginTop: 10, width: '100%' }} onClick={onSignOut}>
            Sign out
          </button>
          <button
            className="theme-toggle"
            onClick={toggle}
            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          >
            <span>{theme === 'light' ? 'Light mode' : 'Dark mode'}</span>
            <span aria-hidden="true">{theme === 'light' ? '\u25CB' : '\u25CF'}</span>
          </button>
        </div>
      </aside>
      <main className="main">
        <div className="topbar">
          <div>
            <h1>{current?.label ?? 'Not found'}</h1>
            {current ? <div className="question">{current.question}</div> : null}
          </div>
          <span className="pill">{progress.built} of {progress.total} screens</span>
        </div>
        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
